export class DropDownOption<T> {
  public label: string;
  public value: T | string;

  constructor(label: string, value?: T) {
    this.label = label;
    this.value = value ? value : label;
  }
}
